<script setup lang="ts">
  import { Skeleton } from '@travelata-libs/ui-kit';

  /** Ширины повторяют строку фильтров из макета: кнопка-иконка и три чипа разной длины. */
  const PILL_WIDTHS = ['44px', '124px', '100px', '120px'];
</script>

<template>
  <div
    class="serp-quick-filters-skeleton"
    aria-hidden="true"
    data-testid="serp-quick-filters-skeleton"
  >
    <div
      v-for="width in PILL_WIDTHS"
      :key="width"
      class="serp-quick-filters-skeleton__pill"
    >
      <Skeleton
        :width="width"
        height="32px"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
  .serp-quick-filters-skeleton {
    align-items: center;
    box-sizing: border-box;
    display: flex;
    gap: var(--spacing-xxs);
    overflow: hidden;
    padding: var(--spacing-s) var(--spacing-m);
    width: 100%;

    // Скруглять сам Skeleton нечем — у него только ширина и высота, поэтому режем обёрткой.
    &__pill {
      border-radius: var(--rounding-xl);
      display: flex;
      flex: 0 0 auto;
      overflow: hidden;
    }
  }
</style>
